import { call, put, takeLatest } from "redux-saga/effects";
import request from "@util/net/request";
import axios, { AxiosResponse } from "axios";
import {
  GET_STYLING_OFFICIAL_LARGE_IMAGE_LIST,
  GET_STYLING_OFFICIAL_LIST,
  OfficialListActions,
  StylingFilterActions
} from "@redux/reducer";
import {
  FiltersResponseType,
  LargeOfficialStylingPayload,
  LargeOfficialStylingUgcPayload,
  LargeOfficialStylingUgcResponse,
  OfficialListPayload,
  OfficialListUgcPayload,
  OfficialListUgcResponse
} from "@type/index";
import {
  checkFeatureCode,
  FeatureFilterMapper,
  FeatureLargeImgMapper,
  OfficialLargeQuery,
  OfficialNormalQuery
} from "@util/net/queryParameters";

export function* loadOfficialListSaga(action: {
  payload: OfficialListPayload;
}) {
  const payload: OfficialListPayload = action.payload;
  const _payload: OfficialListUgcPayload = OfficialNormalQuery(payload);
  try {
    yield put(OfficialListActions.setOfficialListErrorCode(""));
    yield put(OfficialListActions.getStylingOfficialListLoading(true));
    const res: AxiosResponse<OfficialListUgcResponse> = yield call(
      request.get,
      "/official/styles",
      {
        params: { ..._payload }
      }
    );
    if (res.data.status === "nok") {
      yield put(OfficialListActions.setOfficialListErrorCode("503"));
    } else {
      yield put(
        OfficialListActions.getStylingOfficialListSuccess(res.data.result)
      );
    }
  } catch (error) {
    if (!axios.isCancel(error)) {
      yield put(OfficialListActions.setOfficialListErrorCode("503"));
    }
  }
}

export function* loadOfficialLargeListSaga(action: {
  payload: LargeOfficialStylingPayload;
}) {
  try {
    const payload: LargeOfficialStylingPayload = action.payload;
    const _payload: LargeOfficialStylingUgcPayload =
      OfficialLargeQuery(payload);
    yield put(OfficialListActions.getOfficialLargeImageListLoading(true));
    const res: AxiosResponse<LargeOfficialStylingUgcResponse> = yield call(
      request.get,
      "/official/features",
      {
        params: { ..._payload }
      }
    );
    yield put(
      OfficialListActions.getOfficialLargeImageListSuccess(
        FeatureLargeImgMapper(res.data.result)
      )
    );
    const _res: FiltersResponseType = {
      features:
        res.data.result.length > 0
          ? [...FeatureFilterMapper(res.data.result)]
          : []
    };
    checkFeatureCode(_res.features || []);
    yield put(StylingFilterActions.getStylingFiltersSuccess(_res));
  } catch (error) {
    yield put(OfficialListActions.getOfficialLargeImageListLoading(false));
  }
}

export function* watchLoadOfficialListSaga() {
  yield takeLatest<any>(GET_STYLING_OFFICIAL_LIST, loadOfficialListSaga);
  yield takeLatest<any>(
    GET_STYLING_OFFICIAL_LARGE_IMAGE_LIST,
    loadOfficialLargeListSaga
  );
}
